import StockAlertModal from 'components/StockAlertModal';

export default function AlertModal(props) {
    return (
        <StockAlertModal
            symbol={props.item?.symbol}
            currentPrice={props.item?.ask || props.item?.bid}
            item={props.item}
            buttonClassName="watchlist-action-icon"
            iconSize={16}
        />
    );
}
